import type { ComponentType } from "react";
import { useElectricChargingTasks } from "./useElectricChargingTasks";

export interface PendingTask {
  id: string;
  icon: ComponentType;
  color: string;
  title: string;
  subtitle: string;
  actionLabel: string;
  targetPath: string;
}

export interface PageTasks {
  count: number;
  tasks: PendingTask[];
}

export const useTasksSummary = () => ({
  electricCharging: useElectricChargingTasks(),
});
